/** Who fills in the freight editor; staff copy talks about the carrier, customer copy talks to them. */
export enum FreightEditorAudience {
  STAFF = 'staff',
  CUSTOMER = 'customer',
}
